module.exports = __webpack_public_path__ + "img/moon-icon.7b9162a5.svg";